import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  EspecialidadesBySolicitud: [],
};
export const mutations = {
  GET_ESPECIALIDAD_SOLICITUD({ context }, result_especialidades) {
    state.loading = false;
    if (result_especialidades) {
      let especialidades = [];
      Object.entries(result_especialidades).forEach(([key, val]) => especialidades.push(val));
      return (state.EspecialidadesBySolicitud = especialidades);
    }
  },
  SAVE_ESPECIALIDAD_SOLICITUD({ context }, especialidad) {
    state.newEspecialidad = Object.assign({}, especialidad);
  },
};
export const actions = {
  GET_ESPECIALIDAD_SOLICITUD({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data.data);
          commit("SET_LOADING", false);
          commit("GET_ESPECIALIDAD_SOLICITUD", response.data.data.espacialidades);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_ESPECIALIDAD_SOLICITUD({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_ESPECIALIDAD_SOLICITUD", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  DELETE_ESPECIALIDAD_SOLICITUD({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  VERIFICAR_ESPECIALIDAD_SOLICITUD({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          //commit("SAVE_ESPECIALIDAD_SOLICITUD", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
};

export const getters = {
  EspecialidadesBySolicitud: state => state.EspecialidadesBySolicitud,
};
